export const NOTIFICATION_PROMPT = '[NOTIFICATION] NOTIFICATION_PROMPT';

export const notificationPrompt = ({ type = false, additionalData = false }) => ({
  type: NOTIFICATION_PROMPT,
  payload: { type, additionalData },
});
